import client from './client';
import { unwrapData } from './response';

export const NOTIFICATIONS_TODO = [
  'GET /admin/alerts para alertas operativas de stock, citas y pedidos'
];

export const listAdminNotifications = async (params = {}) => {
  const response = await client.get('/admin/notifications', { params });
  return unwrapData(response);
};

export const sendAdminNotification = async (payload) => {
  const response = await client.post('/admin/notifications', payload);
  return unwrapData(response, null);
};
